import React, { useState} from 'react'
import {Pagination} from '../../../../components/Pagination'
import { useDispatch, useSelector } from 'react-redux'
import { State } from '../../../../reducers'
import { comprobanteRetencionDesasociarDoc, creAsociarDocumentosNuevo, creEditarDatosDocumentoFisico } from '../../../../actions/comprobante-retencion/comprobanteRetencionProductos.actions'
import { convertirNumeroConComas } from '../../../../utils/numbers.utils'
import { getFechaCA } from '../../../../utils/stringDate'
import EditIcon from '../../../../media/felsv/PenEdit.svg'

const TableDocumentosCRE = (props: any) => {
  const [tableDocumentos, setTableDocumentos] = useState(props?.rows || [])
  const {tipoDocumentosEmision} = useSelector((state: State) => state.catalogos)
  const documentosAsociados = useSelector((state: State) => state.comprobanteRetencion.documentosAsociados)
  const dispatch = useDispatch()

  return (
    <><table className='table-main-responsive responsive-table-main td-left table-pointer'>
        <TableHead sinAcciones={props?.sinAcciones} columnaNombres={props?.columnaNombres} />
        <tbody>
          {props?.rows?.length > 0 && tableDocumentos.map((documento:any, index:number) => (
            <tr key={index}>
              {props?.columnaNombres === true && <td data-label="Nombre" style={{wordBreak:"break-all"}}>{documento?.nombreReceptor}</td>}
              <td data-label="Tipo de doc. relacionado">{tipoDocumentosEmision?.find((tipo) => tipo.codigodocumento === documento?.TipoDte)?.nombre}</td>
              <td data-label="N° de Control DTE" style={{wordBreak:"break-all"}}>{documento?.numeroControl}</td>
              <td data-label="N° del doc. relacionado" style={{wordBreak:"break-all"}}>{documento?.numDocumento}</td>
              <td data-label="Fecha del doc.">{getFechaCA(documento?.fechaEmision)}</td>
              <td data-label="Monto sujeto a retención">${convertirNumeroConComas(documento?.montoSujetoGrav)}</td>
              <td data-label="IVA retenido">${convertirNumeroConComas(documento?.ivaRetenido)}</td>
              {props?.sinAcciones !== true && 
                <td data-label="Acciones">{documentosAsociados.find((doc: any) => doc?.numDocumento === documento?.numDocumento) ? <button onClick={() => {dispatch(comprobanteRetencionDesasociarDoc(documento?.numDocumento))}} style={{borderRadius: '4px', backgroundColor: "#d90f15", color: "#fff"}}>Quitar</button> : props?.noAsociar === true ? null : <button onClick={() => {dispatch(creAsociarDocumentosNuevo(documento))}}  style={{borderRadius: '4px', background: '#13ad90', color: '#fff'}}>Asociar</button>}{documento?.id && <button onClick={() => dispatch(creEditarDatosDocumentoFisico(documento))}><img alt='Edit' src={EditIcon} /></button>}</td>}
            </tr>
          ))}
        </tbody>
      </table>
      <Pagination data={props?.rows} state={(items: Array<any>) => setTableDocumentos(items)} items={10}/></>)
}

const TableHead = (props:any) => {
  return (
    <thead><tr>
        {props?.columnaNombres === true && <td>Nombre</td>}
        <td>Tipo de doc. relacionado</td>
        <td>N° de Control DTE</td>
        <td>N° del doc. relacionado</td>
        <td>Fecha del doc.</td>
        <td>Monto sujeto a retención</td>
        <td>IVA retenido</td>
        {props?.sinAcciones !== true && <td>Acciones</td>}
      </tr></thead>
  )
}

export default TableDocumentosCRE
